
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientDemographicsMasterParameters extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface  PatientDemographicsMaster {

  id?: any;
  disablityIdNumber: string;
  udidCard: string;
  governmentStipend:string;
  placeOfBirth: string;
  currentMonthlyIncome: string;
  typeOfResidence: string;
  currentJob: string;
  threeWheelerUsage: string;
  wheelChairUsage: string;
  shoulderWithTShirt: string;
  regId:string;
  parameters?: PatientDemographicsMasterParameters[];
  links?: any;

}

export abstract class  PatientDemographicsMasterData {

  abstract list(url: string): Observable<PatientDemographicsMaster[]>;
  abstract create(url: string, data: PatientDemographicsMaster): Observable<any>;
  abstract update(url: string, data: PatientDemographicsMaster): Observable<any>;
}
